import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import {
  matchRoutes,
  useLocation,
  useNavigationType,
  createBrowserRouter,
  createRoutesFromChildren,
} from 'react-router';

import { getEnv } from './config/envs';

Sentry.init({
  environment: getEnv(),
  dsn: 'https://81cb1cfaa10a1c2f6e66ac0cab2fdcfb@o1167571.ingest.us.sentry.io/4508687406465024',
  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  tracesSampleRate: 1.0,
});

export const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);
